export default __webpack_public_path__ + "static/media/ransomware.a93b11aa.png";